export enum HeartType {
    CLASSIC,
    MULTI,
    PIXEL,
    EMPTY,
    SOFT
}